module.exports = __webpack_public_path__ + "static/media/VectorSelect.8e3620c3.svg";